require("core-js/modules/es.date.to-string.js");

var parse = require('../parse/index.js');
/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */


function isFuture(dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime();
}

module.exports = isFuture;